export const CREATE_MEMBER = `
  mutation createMember($input: CreateMemberInput!, $tenant_id: Int!) {
    createMember(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Member {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
          contact_contact_status {
            id
            status_id
            end_date
            status {
              id
              name
              hex_color
            }
          }
        }
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_MEMBER = `
  mutation updateMember($input: UpdateMemberInput!, $tenant_id: Int!) {
    updateMember(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Member {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
          contact_contact_status {
            id
            status_id
            end_date
            status {
              id
              name
              hex_color
            }
          }
        }
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_MEMBER = `
  mutation deleteMember($id: Int!, $tenant_id: Int!) {
    deleteMember(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on Member {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const ADD_MEMBER_TO_HUMAND = `
  mutation addMemberToHumand($member_id: Int!, $tenant_id: Int!) {
    addMemberToHumand(member_id: $member_id, tenant_id: $tenant_id) {
      __typename
      ... on Member {
        id
        contact_id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
